module.exports = __webpack_public_path__ + "img/pay-weixin2.79034feb.png";